import { NAV_ROUTES } from './navRoutes';

export const COMING_SOON_CONTENT = {
  eyebrow: 'Coming Soon',
  title: 'While You Wait...',
  body: 'Check out the Dashboard, Student Action Plans, and the Reports pages to try out the existing features. Do you have feedback or suggestions? Send an email to',
  contactEmail: 'nate.llewellyn@flashlight360.com',
  surveyLabel: 'fill out our feedback survey',
  buttonLabel: 'Go to Dashboard',
  dashboardPath: NAV_ROUTES.dashboard,
} as const;
